// Whole-page fullscreen with the WebKit fallback. iPhone Safari has no page fullscreen, so supported() is false there.
interface Requestable {
  requestFullscreen?: () => Promise<void> | void;
  webkitRequestFullscreen?: () => void;
}

interface Exitable {
  exitFullscreen?: () => Promise<void> | void;
  webkitExitFullscreen?: () => void;
  fullscreenElement?: Element | null;
  webkitFullscreenElement?: Element | null;
}

const page = () => document.documentElement as unknown as Requestable;
const doc = () => document as unknown as Exitable;

export function supported(): boolean {
  return typeof page().requestFullscreen === 'function' || typeof page().webkitRequestFullscreen === 'function';
}

export function isOn(): boolean {
  return !!(doc().fullscreenElement ?? doc().webkitFullscreenElement);
}

export function toggle(): void {
  try {
    const request = isOn()
      ? doc().exitFullscreen?.() ?? doc().webkitExitFullscreen?.()
      : page().requestFullscreen?.() ?? page().webkitRequestFullscreen?.();
    void Promise.resolve(request).catch(() => undefined);
  } catch {
    // Refused (no user gesture, or unsupported): the label stays as it was.
  }
}
